import type * as React from 'react';
import { cn } from './cn';
import { CONTROL } from './formField';

/**
 * Text input. `md:text-sm` keeps mobile at 16px so iOS does not zoom on focus.
 *
 * `h-control` is 32px, the same as `Button`'s default. It was `h-10` — shadcn's
 * size, kept from before the type scale came down — so every filter row in the
 * app stood a search field 5px taller than the buttons beside it and nothing
 * shared a baseline. The ladder and the measurements are in `globals.css`.
 *
 * No `forwardRef`: since React 19 a ref is an ordinary prop, and
 * `ComponentProps<'input'>` already carries it.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return <input type={type} className={cn('flex h-control', CONTROL, className)} {...props} />;
}

export { Input };
